import React, { useCallback, useMemo, useState, useEffect } from "react";
import '../../../../../assets/css/revised_css/components/controlManagerThemes/bootstrap/image.css'
import '../../../../../assets/css/revised_css/components/chatInline.css'
import { Copy, Check, Settings, Info, Trash, X } from 'react-feather';
import { Col, Form, Row, Popover, OverlayTrigger } from "react-bootstrap";
import { useChat } from 'ai/react';
import { useUserContext } from "../../../../revised_components/contextProviders/userContext";
import ReactQuill from 'react-quill';
import { settings } from "eslint-plugin-import/config/react";
const Delta = ReactQuill.Quill.import('delta');
export function ChatControl({ idx, name, displaySettings = {}, objectMetadata, label, placeholder,
   options = { thumbnailSize: 'md' }, setGetLastAssistantMessage, initialInput, forceInputUpdate,
    sidebarOpen, setSidebarOpen, fieldId, initialMessages = [], textSourceRef, onClose, onChange,
    onAddRecommendation,
  selectedRecommendationContents = [],
    ...chatProps }) {
  let beta = ''
  console.log(initialInput);
  const { user } = useUserContext()
  let labelProps = useMemo(() => displaySettings.labelProps ? displaySettings.labelProps : {}, [displaySettings])
  //let fieldId = useMemo(() => objectMetadata?.fieldName, [objectMetadata]);
  let reportId = useMemo(() => objectMetadata?._id, [objectMetadata]);
  let blockId = useMemo(() => objectMetadata?.blockId, [objectMetadata]);
  let blockName = useMemo(() => objectMetadata?.blockName, [objectMetadata]);

  const { messages, input, handleInputChange, isLoading, append } = useChat({
    //api: `${process.env.REACT_APP_PROTOCOL}:${process.env.REACT_APP_APP_URL}${beta}/chat/chat`,
    api: `${process.env.REACT_APP_PROTOCOL}:${process.env.REACT_APP_APP_URL}${beta}/chat/assistant-chat`,
    headers: {
      'Authorization': `Bearer ${user.token}`,
      'Content-Type': 'application/json'
    },
    experimental_streamData: true,
    initialMessages, 
  });

  const [normalizedMessages, setNormalizedMessages] = useState([]);
  const normalizedMessagesRef = React.useRef([]);
  const [insertToNarrative, setInsertToNarrative] = useState(true);
  const inputRef = React.useRef(null);
  const [originalUserInput, setOriginalUserInput] = useState('');
  const [lastAssistantResponse, setLastAssistantResponse] = useState('');
  const [copiedMessages, setCopiedMessages] = useState(new Set());
  const [additionalInstructions, setAdditionalInstructions] = useState('If the users asked to revise some text fragment, analyse the whole text but edit only the section the user asked for. Return the exact copy of the Full text with only replaced revised fragment. Do not change the rest of the text. Wrap the revised fragment in <em style="color: #639A98 ;"> tags.');
  const [includeAdditionalInstructions, setIncludeAdditionalInstructions] = useState(false);
  const [expandedRequestData, setExpandedRequestData] = useState(new Set());
  const [selectedRecommendations, setSelectedRecommendations] = useState(new Set());
  const messagesEndRef = React.useRef(null); // Ref for scrolling to bottom

     // Create the apply function that inserts content into the target field
  const applyChatResponseTarget = useCallback((content, replaceAll = false, resetColor = false) => {
    // Helper function to get content length safely
    const getContentLength = (content) => {
      if (typeof content === 'string') {
        return content.length;
      }
      if (content && content.ops && Array.isArray(content.ops)) {
        return content.ops.reduce((length, op) => length + (op.insert ? op.insert.length : 0), 0);
      }
      return 0;
    };

    // Helper function to convert HTML to ReactQuill Delta
    const htmlToDelta = (htmlContent, editor) => {
      try {
        // Create a temporary div to parse HTML
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlContent;
        
        // Convert HTML to Delta using ReactQuill's clipboard
        const clipboard = editor.getModule('clipboard');
        const delta = clipboard.convert(htmlContent);
        return delta;
      } catch (error) {
        console.warn('Failed to convert HTML to Delta, falling back to text:', error);
        // Fallback: extract text content
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlContent;
        return tempDiv.textContent || tempDiv.innerText || htmlContent;
      }
    };

    if (textSourceRef?.current) {
      const el = textSourceRef.current;
      const savedScrollX = window.scrollX;
      const savedScrollY = window.scrollY;

      const restoreScroll = () => {
        window.scrollTo(savedScrollX, savedScrollY);
      };

      // Handle ReactQuill instance
      if (typeof el.getEditor === 'function') {
        const editor = el.getEditor();
        
        // Convert HTML content to Delta if it's a string that looks like HTML
        let processedContent = content;
        if (typeof content === 'string' && (content.includes('<') && content.includes('>'))) {
          processedContent = htmlToDelta(content, editor);
        }
        
        if (replaceAll) {
          // Replace entire content with the provided content
          if (typeof processedContent === 'string') {
            editor.setText(processedContent, 'silent');
          } else {
            editor.setContents(processedContent, 'silent');
          }
        } else {
          const selection = editor.getSelection();
          
          if (selection && selection.length > 0) {
            // Replace selected text with AI response content
            editor.deleteText(selection.index, selection.length, 'silent');
            if (typeof processedContent === 'string') {
              editor.insertText(selection.index, processedContent, 'silent');
            } else {
              editor.updateContents(new Delta().retain(selection.index).insert(processedContent), 'silent');
            }
          } else {
            // If no selection, insert at the end
            const currentContent = editor.getContents();
            const currentLength = currentContent.ops.reduce((length, op) => length + (op.insert ? op.insert.length : 0), 0);
            if (typeof processedContent === 'string') {
              editor.insertText(currentLength, processedContent, 'silent');
            } else {
              editor.updateContents(new Delta().retain(currentLength).insert(processedContent), 'silent');
            }
          }
        }
        
        onChange?.(editor.root.innerHTML, 1);
        restoreScroll();

      } else {
        // Handle regular <textarea> or <input>
        if (replaceAll) {
          // Replace entire content with AI response
          el.value = content;
        } else {
          const value = el.value;
          const selectionStart = el.selectionStart;
          const selectionEnd = el.selectionEnd;
          
          if (selectionStart !== selectionEnd) {
            // Replace selected text
            el.value = value.substring(0, selectionStart) + `[AI Response: ${content}]` + value.substring(selectionEnd);
          } else {
            // If no selection, insert at the end
            el.value = value + (value.endsWith('\n') ? '\n' : '\n\n') + `[AI Response: ${content}]`;
          }
        }
        
        onChange?.(el.value);
        el.dispatchEvent(new Event('input', { bubbles: true }));
        restoreScroll();
      }
    }
  }, [textSourceRef]);

  useEffect(() => {
    const normalized = messages.map((m) => {
      let parsedContent = null;

      if (typeof m.content === 'string') {
        try {
          const parsed = JSON.parse(m.content);
          if (parsed && typeof parsed === 'object') {
            parsedContent = parsed;
          }
        } catch {
          parsedContent = null;
        }
      } else if (m.content && typeof m.content === 'object') {
        parsedContent = m.content;
      }

      const normalizedContent = parsedContent && typeof parsedContent.text === 'string'
        ? parsedContent.text
        : (typeof m.content === 'string' ? m.content : (m.content?.text || ''));

      const normalizedRecommendations = Array.isArray(parsedContent?.recommendations)
        ? parsedContent.recommendations
          .filter((item) => typeof item === 'string' && item.trim().length > 0)
          .map((item) => item.trim())
        : [];

      const isFallback = Boolean(parsedContent?.fallback);

      return {
        ...m,
        content: normalizedContent,
        recommendations: normalizedRecommendations,
        requestData: m.requestData || null,
        isFallback
      };
    });
    
        // Check if this is a new message (not from history)
    const isNewMessage = normalizedMessages?.length > 0
    && (normalized.length > normalizedMessages.length);
    
    if (isNewMessage) {
      const lastMessage = normalized[normalized.length - 1];
      if (lastMessage.role === 'assistant' && lastMessage.content) {
        setLastAssistantResponse(lastMessage.content);
        
        if (insertToNarrative && !lastMessage.isFallback) {
          setTimeout(() => {
            applyChatResponseTarget(lastMessage.content, true); // Replace all content
          }, 100);
        }
      }
    }

    setNormalizedMessages(normalized);
    normalizedMessagesRef.current = normalized;
  }, [messages]);


  // Custom handleSubmit to include fieldId in each message
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!input.trim()) return;
    
    const userText = input;
    handleInputChange({ target: { value: '' } });
    if (inputRef.current) {
      inputRef.current.value = '';
      inputRef.current.style.height = 'auto';
    }
    
    // Store the original user input from textSourceRef when they first submit
    if (originalUserInput === '' && textSourceRef?.current) {
      const el = textSourceRef.current;
      if (typeof el.getEditor === 'function') {
        // For ReactQuill, get the formatted content with styles
        const editor = el.getEditor();
        const content = editor.getContents();
        setOriginalUserInput(content);
      } else {
        // For regular textarea/input
        setOriginalUserInput(el.value);
      }
    }
    
    // Build instructions based on checkbox states
    let instructionsToSend = '';

    if (includeAdditionalInstructions && additionalInstructions.trim()) {
      instructionsToSend += (instructionsToSend ? '\n\n' : '') + additionalInstructions.trim();
    }

    let additionalSettings = {
      includeFullText: chatProps ? chatProps.includeFullText : false
    }
    
    // Assume reportId is available in scope (from props, state, or context)
    console.log('Sending fieldId:', fieldId, 'reportId:', reportId, 'and blockId:', blockId);
    append({
      // Insert report context here
      content: {
        reportId,
        blockId,
        blockName,
        fieldId,
        text: userText,
        additional_instructions: instructionsToSend || undefined,
        additional_settings: additionalSettings
      },
      role: 'user'
    });
    
    // Reset input value after sending
    handleInputChange({ target: { value: '' } });
    if (inputRef.current) {
      inputRef.current.value = '';
      inputRef.current.style.height = 'auto';
    }
  };

  const handleInputKeyDown = useCallback((e) => {
    if (e.key === 'Enter' && !e.shiftKey && !e.nativeEvent?.isComposing) {
      e.preventDefault();
      handleSubmit(e);
    }
  }, [handleSubmit]);

  // Provide a getter for the last assistant message
  React.useEffect(() => {
    if (setGetLastAssistantMessage) {
      setGetLastAssistantMessage(() => () => {
        const last = [...normalizedMessagesRef.current].reverse().find(m => m.role === 'assistant');
        return last ? last.content : '';
      });
    }
  }, [setGetLastAssistantMessage]);
  
  // Set initial input if provided
  const [hasSetInitialInput, setHasSetInitialInput] = React.useState(false);
  
  React.useEffect(() => {
    if(sidebarOpen){
      if (initialInput && !hasSetInitialInput) {
        handleInputChange({ target: { value: initialInput } });
        setHasSetInitialInput(true);
      }
    } else {
      setHasSetInitialInput(false);
    }
  }, [sidebarOpen, initialInput, handleInputChange]);

  // Focus chat input when the sidebar opens so typing can start immediately.
  useEffect(() => {
    if (!sidebarOpen) return;

    const frameId = requestAnimationFrame(() => {
      const el = inputRef.current;
      if (!el) return;
      el.focus({ preventScroll: true });
      const cursorPosition = el.value?.length || 0;
      el.setSelectionRange(cursorPosition, cursorPosition);
    });

    return () => cancelAnimationFrame(frameId);
  }, [sidebarOpen]);

  // Handle force input updates (when refine button is clicked again)
  React.useEffect(() => {
    if (forceInputUpdate && sidebarOpen) {
      handleInputChange({ target: { value: forceInputUpdate } });
    }
  }, [forceInputUpdate, sidebarOpen]);
  // Reset hasSetInitialInput when sidebar is closed

 
  const copyLastResponse = useCallback(() => {
    const last = [...normalizedMessagesRef.current].reverse().find(m => m.role === 'assistant');
    if (last?.content) { 
        // Fallback to clipboard copy
        navigator.clipboard?.writeText(last.content);   
    }
  }, [textSourceRef, applyChatResponseTarget]);

  const copyMessage = useCallback((content, messageIndex) => {
    if (content) {
      navigator.clipboard?.writeText(content);
      // Mark this message as copied
      setCopiedMessages(prev => new Set([...prev, messageIndex]));
      // Reset the checkmark after 2 seconds
      setTimeout(() => {
        setCopiedMessages(prev => {
          const newSet = new Set(prev);
          newSet.delete(messageIndex);
          return newSet;
        });
      }, 2000);
    }
  }, []);

  const toggleRequestData = useCallback((messageIndex) => {
    setExpandedRequestData(prev => {
      const newSet = new Set(prev);
      if (newSet.has(messageIndex)) {
        newSet.delete(messageIndex);
      } else {
        newSet.add(messageIndex);
      }
      return newSet;
    });
  }, []);

  // Scroll to bottom of chat messages
  const scrollToBottom = useCallback((smooth) => {
    const messagesContainer = document.querySelector('.chat-messages');
    if (messagesContainer) {
      if (smooth) {
      messagesContainer.scrollTo({
        top: messagesContainer.scrollHeight,
        behavior: 'smooth'
      });
      } else {
        messagesContainer.scrollTop = messagesContainer.scrollHeight;
      }
    }
  }, []);

  // Scroll to bottom when messages change (smooth) or chat opens (instant)
  useEffect(() => {
    if (sidebarOpen) {
      scrollToBottom(false); // Instant scroll when opening
    }
  }, [normalizedMessages, sidebarOpen, scrollToBottom]);

  useEffect(() => {
    if (lastAssistantResponse && normalizedMessages.length > 0) {
      scrollToBottom(true); // Smooth scroll when new messages arrive
    }
  }, [normalizedMessages, lastAssistantResponse, scrollToBottom]);

  const latestAssistantRecommendationIndex = useMemo(() => {
    for (let i = normalizedMessages.length - 1; i >= 0; i -= 1) {
      const message = normalizedMessages[i];
      if (message.role === 'assistant' && Array.isArray(message.recommendations) && message.recommendations.length > 0) {
        return i;
      }
    }

    return -1;
  }, [normalizedMessages]);

  const normalizedSelectedRecommendations = useMemo(() => {
    return new Set(
      (selectedRecommendationContents || [])
        .filter((item) => typeof item === 'string')
        .map((item) => item.trim())
        .filter(Boolean)
    );
  }, [selectedRecommendationContents]);


  const handleRecommendationClick = useCallback((recommendation) => {
    if (!onAddRecommendation) return;
    const normalizedRecommendation = recommendation.trim();
    if (!normalizedRecommendation || normalizedSelectedRecommendations.has(normalizedRecommendation) || selectedRecommendations.has(normalizedRecommendation)) {
      return;
    }
    onAddRecommendation(recommendation);
    setSelectedRecommendations((prev) => new Set(prev).add(normalizedRecommendation));
  }, [onAddRecommendation, normalizedSelectedRecommendations, selectedRecommendations]);

function AdditionalInstructionsPopover(props) {
  return (
    <Popover {...props} className="additional-instructions-section">

       
            
              <div className="instructions-header">
                <strong>Add run instructions</strong>
                <p>Use to provide additional context to assistant.</p>
              </div>
                      
              {/* Additional Instructions */}
              <div className="additional-instructions-group">
                <textarea
                  value={additionalInstructions}
                  onChange={(e) => setAdditionalInstructions(e.target.value)}
                  placeholder="eg. be short"
                  className="instructions-textarea"
                  rows={3}
                />
                <Form.Check>
                  <Form.Check.Input 
                    type="checkbox" 
                    checked={includeAdditionalInstructions}
                    onChange={(e) => setIncludeAdditionalInstructions(e.target.checked)}
                  />
                  <Form.Check.Label>Include additional instructions</Form.Check.Label>
                </Form.Check>
              </div>
           

      
    </Popover>
  )
}
  let comp = useMemo(() => {

     let labelElm = label ? (  
        <Form.Label {...labelProps}>{label}</Form.Label>
      ) : []

      return (
        <div className="chat-container">
          <div className="chat-header">
            {labelElm}
       
            <div className="chat-header-controls">
            {onClose && (
                <button 
                  type="button" 
                  className="chat-close-btn"
                  onClick={onClose}
                  title="Close chat"
                >
                  <X size={16} />
                </button>
              )}
              {normalizedMessages?.length > 0 && (
              <button 
                 type="button" 
                 className="chat-clear-btn"
                 onClick={async () => {
                   if (window.confirm('Are you sure you want to clear the chat history?')) {
                     try {
                       const response = await fetch(`${process.env.REACT_APP_PROTOCOL}:${process.env.REACT_APP_APP_URL}/chat/clear-thread`, {
                         method: 'POST',
                         headers: {
                           'Authorization': `Bearer ${user.token}`,
                           'Content-Type': 'application/json'
                         },
                         body: JSON.stringify({
                           reportId,
                           fieldId
                         })
                       });
                       
                       const result = await response.json();
                       
                       if (result.success) {
                         // Clear the messages in the UI by remounting the chat wrapper
                         if (setSidebarOpen) {
                           setSidebarOpen(false);
                           setTimeout(() => setSidebarOpen(true), 100);
                         }
                       } else {
                         alert('Failed to clear chat: ' + (result.error || 'Unknown error'));
                       }
                     } catch (error) {
                       console.error('Error clearing chat:', error);
                       alert('Failed to clear chat: ' + error.message);
                     }
                   }
                 }}
                 title="Clear chat history"
               >
                 <Trash size={14} />
               </button>
              )}
            </div>
          </div>

         
          <div>
            {/* Chat box */}
            <div className="chat-messages">
              {normalizedMessages.map((m, i) => {
                const hasRecommendations = m.role === 'assistant' && Array.isArray(m.recommendations) && m.recommendations.length > 0;
                const isLatestRecommendationGroup = i === latestAssistantRecommendationIndex;

                return (
                <div        
                  key={i}
                  className={`chat-msg ${m.role === 'user' ? 'user' : 'bot'}`}
                >
                  <div className="chat-msg-body">
                    {/* Bubble */}
                    <span className={`chat-bubble ${m.role === 'user' ? 'user' : 'bot'}`}>
                      {m.content}
                      {m.role === 'assistant' && (
                        <button 
                          type="button" 
                          className="chat-close-btn chat-copy-btn"
                          onClick={() => copyMessage(m.content, i)}
                          title="Copy this response">
                          {copiedMessages.has(i) ? <Check size={18} /> : <Copy size={18} />}
                        </button>
                      )}
                      {/* It works but hidden for UX simplicity
                      {m.role === 'user' && m.requestData && (
                        <button 
                          type="button" 
                          className="chat-close-btn chat-request-data-btn"
                          onClick={() => toggleRequestData(i)}
                          title="Show request data">
                          <Info size={18} />
                        </button>
                      )
                      
                      {m.role === 'user' && m.requestData && expandedRequestData.has(i) && (
                        <div className="request-data-display">
                          <div className="request-data-section">
                            <strong>Content sent to ChatGPT:</strong>
                            <div className="request-data-content">
                              {m.requestData.content.map((item, idx) => (
                                <div key={idx} className="content-item">
                                  <strong>{item.type}:</strong> {item.text}
                                </div>
                              ))}
                            </div>
                          </div>
                          {m.requestData.additional_instructions && (
                            <div className="request-data-section">
                              <strong>Additional Instructions:</strong>
                              <div className="request-data-content">
                                {m.requestData.additional_instructions}
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                      */}
                    </span>

                    {hasRecommendations && (
                      <div className={`chat-message-recommendations${isLatestRecommendationGroup ? '' : ' chat-message-recommendations--compact'}`}>
                        {isLatestRecommendationGroup && (
                          <div className="chat-recommendations-title">Recommendations from AI</div>
                        )}
                        <div className={`chat-recommendations-list${isLatestRecommendationGroup ? ' chat-recommendations-list--latest' : ' chat-recommendations-list--compact'}`}>
                          {m.recommendations.map((recommendation, recommendationIndex) => {
                            const normalizedRecommendation = recommendation.trim();
                            const isSelected = normalizedSelectedRecommendations.has(normalizedRecommendation)
                              || selectedRecommendations.has(normalizedRecommendation);

                            return (
                              <button
                                key={`${i}-${recommendationIndex}-${recommendation.slice(0, 32)}`}
                                type="button"
                                className={`chat-recommendation-card${onAddRecommendation ? ' chat-recommendation-card--clickable' : ''}${isSelected ? ' chat-recommendation-card--selected' : ''}${isLatestRecommendationGroup ? '' : ' chat-recommendation-card--compact'}`}
                                onClick={() => handleRecommendationClick(recommendation)}
                                disabled={!onAddRecommendation || isSelected}
                                title={isSelected ? 'Recommendation already added' : 'Add as recommendation block'}
                              >
                                <div className="chat-recommendation-text">{recommendation}</div>
                                <div className="chat-recommendation-card-meta">
                                  {!isSelected && <span className="chat-recommendation-approve-badge">
                                    <Check size={12} />
                                    Approve
                                  </span>}
                                  {isSelected && <span className="chat-recommendation-selected-label">Added</span>}
                                </div>
                              </button>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )})}

              {/* Typing animation */}
              {isLoading && (
                <div className="chat-msg bot typing-animation">
                  <div className="avatar">🤖</div>
                  <div className="chat-bubble bot">AI is typing…</div>
                </div>
              )}
              {/* Invisible element for scrolling to bottom */}
              <div ref={messagesEndRef} />
            </div>
              

            {/* Controls row */}
            { normalizedMessages?.length > 0 && (
            <div className="chat-controls-row">
              <Form.Check>
                <Form.Check.Label for="insertToNarrative">Insert new language to narrative</Form.Check.Label>
                <Form.Check.Input type="checkbox" id="insertToNarrative" checked={insertToNarrative} 
                onChange={(e)=>{
                  const newValue = e.target.checked;
                  setInsertToNarrative(newValue);
                  
                  // If turning on and we have a last response, apply it
                  if (newValue && lastAssistantResponse) {
                    setTimeout(() => {
                      applyChatResponseTarget(lastAssistantResponse, true);
                    }, 100);
                  }
                  // If turning off, restore original user input
                  else if (!newValue && originalUserInput) {
                    setTimeout(() => {
                      applyChatResponseTarget(originalUserInput, true, true); // Reset color to black
                    }, 100);
                  }
                }} />
              </Form.Check>      
            </div>
            )}
  
            {/* Input form */}
            <form onSubmit={handleSubmit} className="chat-input-bar">
              <textarea
                ref={el => {
                  inputRef.current = el;
                  if (el) {
                    el.style.height = 'auto';
                    el.style.height = el.scrollHeight + 'px';
                  }
                }}
                value={input}
                onChange={e => {
                  handleInputChange(e);
                  const el = e.target;
                  el.style.height = 'auto';
                  el.style.height = el.scrollHeight + 'px';
                }}
                onKeyDown={handleInputKeyDown}
                placeholder="Ask anything"
                rows={1}
                className="chat-input"
                style={{ overflow: 'hidden' }}
              />
              
              <div className="chat-input-controls">
                {/* It works but hidden for UX simplicity
                <OverlayTrigger
                  rootClose
                  trigger={['click']}
                  overlay={(props) => AdditionalInstructionsPopover(props)}
                >
                  <button 
                    type="button" 
                    className="chat-settings-btn"
                    title="Additional instructions"
                  >
                    <Settings size={16} />
                  </button>
                </OverlayTrigger>    
                */}
                <button
                  type="submit"
                  className="chat-send-btn"
                  disabled={isLoading || !input.trim()}
                  title={!input.trim() ? 'Type the prompt first' : 'Send message'}
                >
                  {isLoading ? 'SENDING...' : 'SEND'}
                </button>
              </div>
           
            </form>
          </div>
        </div>
      );
      
      
  }, [label, displaySettings, normalizedMessages, input, handleInputChange, handleSubmit, handleInputKeyDown, isLoading, insertToNarrative, copyLastResponse, additionalInstructions, includeAdditionalInstructions, expandedRequestData, toggleRequestData, latestAssistantRecommendationIndex, onAddRecommendation, handleRecommendationClick, normalizedSelectedRecommendations, selectedRecommendations])
  return comp
}